<template>
  <div class="supermarket-topbar">
    <div class="top-logo">
      <!-- <img :src="imgsrc" alt="" /> -->
       <img :src="logoimg" alt="" v-if="!islogo2">
       <img :src="logoimg2" alt="" v-else>
       <!-- <p class="top-logo-text">企业数据资源市场</p> -->
    </div>
    <div class="top-list">
      <ul>
        <li><router-link to="/dataMarket">首页 </router-link></li>
        <li>
          <router-link to="/Dataset">数据资源</router-link>
        </li>
                 <li><a href="javascript:void(0)" @click="returnGo($event)">关于我们</a></li>
      </ul>
    </div>
    <div class="publish-btn" v-if="!login">
      <a class="upload" disabled @click.prevent
        ><i class="iconfont icon-fabusekuai"></i
        ><label for="upload" @click.prevent="disabled">发布数据资源</label></a
      >
      <input type="file" id="upload" @change.prevent="handleUpload" />
    </div>
    <div class="m" v-if="!login">
      <a class="upload" disabled @click.prevent="handleGo"
        ><i class="iconfont icon-fabusekuai"></i
        ><label for="upload">发布数据需求</label></a
      >
    </div>
    <div class="login" v-if="userInfo===null">
      <a class="login-btn" @click.prevent="handlepush('/login')">登录</a>
      <a class="signup-btn" @click.prevent="showmessage">注册</a>
    </div>
    <div class="avatar" v-else>
      <img :src="avatarimg" alt="" @click="handleRole()" />
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import logoimg from "@/assets1/高新区logo/logo-白.png";
import { calculateFileHash } from "@/utils/upload";
import avatarimg from "@/assets1/首页-未登录_slices/avatar.png";
import logo from "@/assets1/首页-未登录_slices/导航栏-logo.png";
import { getSTStoken, postUpload } from "@/api/file";
import { postDataset, addViewNum, updataDataset } from "@/api/Dataset";
import logoimg2 from "@/assets1/高新区logo/logo-黑.png";
export default {
  async created() {
    // 初始化时同步store中的userInfo
    this.userInfo = this.$store.state.userInfo;
    console.log('Component created, userInfo:', this.userInfo);
    
    // window.updataDataset=updataDataset(104,{
    //  "name": "DuEE-fin金融领域篇章级事件抽取数据集",
    //     "data_type": "CSV",
    //     "cover_bucket": "sxdatasets",
    //     "cover_object": "5/cover/json.jpg",
    //     "profile":"DuEE-fin（Financial Event Extraction Dataset）是一个专为训练和评估金融领域内的事件抽取模型而设计的数据集合，利用此数据集训练出的AI模型可以自动从大量金融新闻中提取关键事件，并生成简洁的摘要，帮助投资者快速获取市场动态，辅助决策过程",
    //     "tags": [
    //         "金融服务"
    //     ],
    //     "test_file_bucket": "sxdatasets",
    //     "test_file_object": "5/dataset/json.jpg",
    //     "file_hash": "c825d361d92df5fa7e904002666dd74da1f411b1608e3123e9cfa87b724d544f",
    //     "file_bucket": "sxdatasets",
    //     "file_object": "5/dataset/DuEE-fin金融领域篇章级事件抽取数据集测试文件.json",
    //     "description": "DuEE-fin（Financial Event Extraction Dataset）是一个专为训练和评估金融领域内的事件抽取模型而设计的数据集合，利用此数据集训练出的AI模型可以自动从大量金融新闻中提取关键事件，并生成简洁的摘要，帮助投资者快速获取市场动态，辅助决策过程",
    //     "data_structure": "无",
    //     "comments": "无",
    //     "status": 1,
    //     "size": 142381209
    // })
  },
  data() {
    return {
      logo,
      logoimg2,
      avatarimg,
      userInfo:null,
      logoimg
    };
  },

  props: {
    color: {
      default: " rgba(255, 255, 255, .6)",
    },
    activeColor: {
      default: "#fff",
    },
    img: {
      default: logo,
    },
    bg: {
      default: "transparent",
    },
    signUp: {
      default: "#fff",
    },
    login: {
      default: false,
    },
    loginColor: {},
    imgsrc: {},
    islogo2: {
      default: false,
    },
  },
  watch: {
    "$store.state.userInfo": {
      handler(newVal) {
        console.log(newVal, "newValuserInfo");
        this.userInfo = newVal;
      },
      deep: true,
      immediate: true
    },
    // 监听computed属性，更可靠
    storeUserInfo: {
      handler(newVal) {
        console.log('storeUserInfo changed:', newVal);
        this.userInfo = newVal;
      },
      immediate: true
    }
  },
  computed: {
    logincolor() {
      if (this.loginColor) {
        return this.loginColor;
      }
      return this.color;
    },
    // 使用computed属性来监听store中的userInfo
    storeUserInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
         returnGo(e){
       Message({
         message: "暂未开放",
         type: "warning",
       });
     },
    disabled() {
      Message({
        message: "暂未开放",
        type: "warning",
      });
      return;
    },
    handleRole() {
      if (!this.$store.state.userInfo) {
        this.$router.push("/login");
        Message({
          message: "请先登录",
          type: "warning",
        });
        return;
      }
      //  alert('1')
      console.log(this.$route, "this.$route");
      //  console.log(this.$store.state.userInfo,'this.$store.state.userInfo');
      console.log(
        this.$store.state.public_key,
        "this.$store.state.public_keyLogin"
      );
      console.log(
        this.$store.state.userInfo.role,
        "this.$store.state.userInfo.role"
      );

      if (
        (this.$store.state.public_key === null||this.$store.state.public_key === undefined) &&
        this.$store.state.userInfo.role === 0
      ) {
        Message({
          message: "请下载数字镖局客户端登录卖方后台",
          type: "warning",
        });
        return;
      }
      if (this.$route.path !== "/release") {
        this.$router.push("/release");
        debugger;
        if (
          this.$store.state.userInfo.role === 1 ||
          this.$store.state.userInfo.role === 0
        ) {
          this.$store.commit("setType", 2);
          console.log(
            this.$store.state.userInfo,
            "this.$store.state.userInfo.role"
          );
        } else if (this.$store.state.userInfo.role === 2) {
          this.$store.commit("setType", 3);
        }
      } else {
        if (
          this.$store.state.userInfo.role === 1 ||
          this.$store.state.userInfo.role === 0
        ) {
          this.$store.commit("setType", 2);
        } else if (this.$store.state.userInfo.role === 2) {
          this.$store.commit("setType", 3);
        }
      }
    },
    handleGo() {
      if (
        localStorage.getItem("token") !== null ||
        sessionStorage.getItem("token") !== null
      ) {
        this.$store.commit("setType", 1);
        if (this.$route.path !== "/release") {
          this.$router.push("release");
        }
      } else {
        this.$router.push("/login");
        Message({
          message: "请先登录",
          type: "warning",
        });
        return;
      }
    },
    async handleUpload(e) {
      // const [file] = e.target.files;
      // const fd = new FormData();
      // fd.append("file", file);
      // const data = await postUpload(fd);
      // console.log(data);
      // await getSTStoken()
      Message({
        message: "暂未开放上传功能",
        type: "warning",
      });
      return;
      //     const res=await calculateFileHash(e.target.files[0])
      // console.log(res);
    },
    showmessage() {
      // Message({
      //           message: '暂未开放注册',
      //           type: 'warning'
      //         });
      this.$router.push("/SignUp");
    },
    handlepush(it) {
      this.$router.push(it);
    },
    async handletest() {
      return;
      const res = await postDataset({
        name: "火灾检测数据集",
        data_type: "Image",
        cover_bucket: "sxdatasets",
        cover_object: "5/cover/火灾检测数据集封面.jpg",
        profile: "该数据集是一个专门用于火灾检测和识别的高质量图像集合",
        tags: ["应急管理"],
        file_bucket: "sxdatasets",
        file_object: "5/dataset/火灾检测数据集内容.jpg",
        file_hash:
          "00cd6dbdcf816d48eca581b0a2e8e4ed86cc0e6c20ffe3ab41811c04da6c6fac",
        test_file_bucket: "sxdatasets",
        test_file_object: "5/dataset/火灾检测数据集内容.jpg",
        description: "该数据集是一个专门用于火灾检测和识别的高质量图像集合",
        data_structure: "jpg",
        comments: "无",
        status: 1,
        size: 521282934,
      });
      console.log(res);
    },
  },
};
</script>

<style scoped>
.top-logo-text{padding-top: 6px;

  color: #fff;
  font-family: Medium;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
}
.m a {
  display: flex;
  font-size: 14px;
}
.m {
  margin-left: 20px;
  color: #fff;
  padding: 0 8px;
  height: 30px;
  line-height: 30px;
  background-color: #ff7a17;
  font-family: Regular;
  border-radius: 15px;
  display: flex;
  justify-content: center;
}
.avatar {
  cursor: pointer;
  width: 36px;
  height: 36px;
  margin-left: 70px;
}
.active {
  color: v-bind(activeColor); /* 选中时的链接颜色为黄色 */
  font-weight: Medium;
}
.upload label {
  cursor: pointer;
}
#upload {
  display: none;
}
.login-btn {
  margin-left: 80px;
  margin-right: 25px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.signup-btn {
  width: 78px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  display: block;
  border-radius: 20px;
  border: 1px solid v-bind(signUp);
  color: v-bind(signUp);
  cursor: pointer;
}
.login {
  color: v-bind(logincolor);
  font-family: Regular;
  font-size: 16px;
  display: flex;
}
.publish-btn {
  color: #fff;

  width: 112px;
  height: 30px;
  line-height: 30px;
  background-color: #0d53ff;
  font-family: Regular;
  border-radius: 15px;
  display: flex;
  justify-content: center;
}
.icon-fabusekuai {
  margin-right: 4px;
}
.publish-btn a {
  display: flex;
  font-size: 14px;
}
.supermarket-topbar {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  padding: 19px 40px;
  display: flex;
  align-items: center;
  background-color: v-bind(bg);
}
.top-list {
  color: v-bind(color);
  padding-top: 4px;
  font-family: Regular;
  height: 40px;
  line-height: 40px;
}
.top-list ul {
  display: flex;
}
.top-list ul li {
  margin-right: 50px;
}

.top-logo {
  flex: 1;
  display: flex;
}
.top-logo img {
  /* width: 293px; */
  height: 45px;
  margin-right: 12px;
}
.router-link-active,
.router-link-exact-active {
  color: v-bind(activeColor); /* 选中时的链接颜色为黄色 */
  font-weight: Medium; /* 选中时加粗 */
}
</style>
